// ======================================================================
// File Name       : content
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function getContentList(data) {
  return commonCallApi({
    path: 'content/GetList',
    data: { ...data },
	  institutionId: 1,
  });
}

export function postQuestionAttributeList(data) {
  return commonCallApi({
    path: 'QuestionAttributeList',
    data: { ...data },
    institutionId: 1,
    drillServer: true,
  });
}

export function questionAttributePackageRegister(data) {
  return commonCallApi({
    path: 'QuestionAttributePackageRegister',
    data: { ...data },
    institutionId: 1,
    drillServer: true,
    muiltipart: 1,
  });
}

export function exportQuestionAttributeIdListCSV(data) {
  return commonCallApi({
    path: 'QuestionAttributeList',
    data: { ...data },
    institutionId: 1,
    drillServer: true,
  });
}

export function getSkinList() {
  return commonCallApi({
    path: 'SkinList',
    drillServer: 1,
  });
}

export function registerContentDrill(registerData) {
  return commonCallApi({
    path: 'DrillRegister',
    data: registerData,
    drillServer: 1,
    muiltipart: 1,
  });
}

export function sendDrillImportRequest(data, options) {
  return commonCallApi({
    ...options,
    path: 'private/DrillPackageRegister',
    data,
    drillServer: true,
    muiltipart: 1,
  });
}

export function sendGetDrillListFileRequest(PARAM_DEFAULT, options) {
  return commonCallApi({
    path: 'private/DrillListDownload',
    data: { ...PARAM_DEFAULT, ...options },
    drillServer: true,
  });
}

export function sendQuestionImportRequest(data, options) {
  return commonCallApi({
    ...options,
    path: 'private/QuestionPackageRegister',
    data,
    drillServer: true,
    muiltipart: 1,
  });
}

export function sendGetQuestionListFileRequest(PARAM_DEFAULT, options) {
  return commonCallApi({
    path: 'QuestionPackageRegisterHistory',
    data: { ...PARAM_DEFAULT, ...options },
    drillServer: true,
  });
}

export function sendImportVideoRequest(data, options) {
  return commonCallApi({
    ...options,
    path: 'fgw2/video/EditList',
    data,
    muiltipart: 1,
  });
}

export function sendGetVideoListFileRequest(PARAM_DEFAULT, options) {
  return commonCallApi({
    path: 'fgw2/document/EditListResult',
    data: { ...PARAM_DEFAULT, ...options },
  });
}

export function searchNotificationMessage(params) {
  return commonCallApi({
    path: 'NotifyMessageList',
    data: params,
    drillServer: 1,
  });
}

export function downloadNotificationMessage(id) {
  return commonCallApi({
    path: 'NotifyMessageDownload',
    data: id,
    drillServer: 1,
  });
}

export function registerNotificationMessage(params) {
  return commonCallApi({
    path: 'NotifyMessageRegister',
    data: params,
    drillServer: 1,
    muiltipart: 1,
  });
}

export function updateNotificationMessage(params) {
  return commonCallApi({
    path: 'NotifyMessageUpdate',
    data: params,
    drillServer: 1,
    muiltipart: 1,
  });
}

export function deleteNotificationMessage(params) {
  return commonCallApi({
    path: 'NotifyMessageDelete',
    data: params,
    drillServer: 1,
  });
}

export function getDrillList(params) {
  return commonCallApi({
    path: 'DrillList',
    data: params,
    drillServer: 1,
  });
}

export function getVideoList(params) {
  return commonCallApi({
    path: 'video/GetList',
    data: params,
    institutionId: 1,
  });
}


export function getAttributeList(data) {
  return commonCallApi({
    path: 'QuestionAttributeList',
    data,
    drillServer: true,
  });
}

export function getQuestionListDrillDetail(data) {
  return commonCallApi({
    path: 'QuestionList',
    data: { ...data },
    institutionId: 1,
    drillServer: 1,
  });
}
